import { render, staticRenderFns } from "./GebruikerToevoegen.vue?vue&type=template&id=b7aa4b74&scoped=true"
import script from "./GebruikerToevoegen.vue?vue&type=script&lang=js"
export * from "./GebruikerToevoegen.vue?vue&type=script&lang=js"
import style0 from "./GebruikerToevoegen.vue?vue&type=style&index=0&id=b7aa4b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aa4b74",
  null
  
)

export default component.exports